module.exports = __webpack_public_path__ + "img/cat-02.fd36d075.png";